var codeObject = {
    code: "profile.mobile-number.customer-enrolled-in-alerts",
    message: "unable to remove mobile number as the account is enrolled in text alerts",
};
var containsErrorString = function (businessErrors) {
    var containsString = false;
    businessErrors.forEach(function (error) {
        if (error.some(function (row) { return row.code === codeObject.code; })) {
            containsString = true;
        }
    });
    return containsString;
};
export default containsErrorString;
